import { useEffect, useMemo } from 'react';
import { syncUserTrackingIdClient } from '../utils/create-user-tracking-id-cookie';
import { getUserIdentifiersClientSafe } from '../utils/user-info';

export interface TrackingData {
  hkSha256Email?: string;
  hkUserTrackingId?: string;
  hkExternalUserId?: string | null;
}

export function useDataLayerScript(): string {
  useEffect(() => {
    syncUserTrackingIdClient();
  }, []);

  const tracking = useMemo<TrackingData>(() => {
    return getUserIdentifiersClientSafe();
  }, []);

  return useMemo(() => {
    const payload = Object.entries(tracking).reduce<Record<string, string>>((acc, [key, value]) => {
      if (value && value !== 'NULL') acc[key] = value;
      return acc;
    }, {});

    return `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(${JSON.stringify(payload)});
    `;
  }, [tracking]);
}
